import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox/';
import { CurrencyInput } from 'ui-components/components/currency-input';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { noop } from 'ui-components/default-props/noop';

import style from './inputs.module.less';
import { emptyObject } from 'ui-components/default-props/empty';
import { CurrencyPropType } from '../../../../prop-types/currency';
import { FormattedMessagePropType } from '../../../../prop-types/intl';

const updateCODValue = (paymentType, value, data, updateOption) => {
  const newValue = {
    ...data,
    payment: {
      ...data.payment,
      value: Number(value) || 0,
    },
    paymentType,
  };

  updateOption({ id: 'collectOnDelivery', value: newValue });
};

const renderCodInput = (data, updateOption, updateInput) => {
  const options = ['Any', 'Cash', 'MoneyOrderOrCashiersCheck'];
  const { payment, paymentType } = data;
  const amount = <FormattedMessage defaultMessage='Amount' description='otherShippingOptions.cod.amount' id='U6yf6R' />;
  const paymentTypeLabel = (
    <FormattedMessage defaultMessage='Payment Type' description='otherShippingOptions.cod.paymentType' id='zGmDAL' />
  );
  return (
    <div className={style['other-input']}>
      <div className={style['cod-payment-type']}>
        <label>{paymentTypeLabel}</label>
        <DropdownMenu className={style['cod-payment-type-dropdown']}>
          <DropdownMenuToggler className={style['bigly-dropdown']}>{paymentType}</DropdownMenuToggler>
          {options.map((option) => (
            <DropdownMenuItem key={option} onClick={() => updateOption(option, payment.value)}>
              {option}
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      </div>
      <div className={style['cod-payment-amount']}>
        <label>{amount}</label>
        <CurrencyInput
          className={style['cod-money-input']}
          currencyCode={payment.code}
          onBlur={(v) => updateOption(paymentType, Number(v))}
          onChange={(v) => updateInput(paymentType, Number(v))}
          value={payment.value}
        />
      </div>
    </div>
  );
};

const CollectOnDeliveryOption = ({
  label,
  checked = false,
  onCheck = noop,
  optionData = emptyObject,
  updateOption = noop,
  updateInput = noop,
}) => {
  const intl = useIntl();

  return (
    <div>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {checked
        ? renderCodInput(
            optionData,
            (paymentType, value) => updateCODValue(paymentType, value, optionData, updateOption),
            (paymentType, value) => updateCODValue(paymentType, value, optionData, updateInput),
            intl,
          )
        : null}
    </div>
  );
};

CollectOnDeliveryOption.propTypes = {
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  optionData: PropTypes.shape({
    payment: CurrencyPropType,
    paymentType: PropTypes.string,
  }),
  updateOption: PropTypes.func,
  updateInput: PropTypes.func,
};

export default CollectOnDeliveryOption;
